export default __webpack_public_path__ + "static/CTAAppMob-4966ba717726e200b8cd2e4f2a985e7c.png";